var map = {
	"./icon_alipay_1.png": 9220,
	"./icon_avatar.png": 6193,
	"./icon_book.png": 7877,
	"./icon_down.png": 8962,
	"./icon_help.png": 9471,
	"./icon_m_search.png": 3794,
	"./icon_next.png": 4017,
	"./icon_search.png": 7022,
	"./icon_search2.png": 2142,
	"./icon_toc.png": 5178,
	"./icon_wepay_1.png": 9882
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6400;